import Created from './Created';
import Name from './Name';
import ShortName from './ShortName';
import Updated from './Updated';
import TaxNumber from './TaxNumber';
import EUTaxNumber from './EUTaxNumber';
import Email from './Email';
import Fax from './Fax';
import Web from './Web';
import Phone from './Phone';
import Felir from './Felir';
import RegistrationNumber from './RegistrationNumber';

export const labels = {
  Name: 'Hivatalos név',
  ShortName: 'Rövid név',
  TaxNumber: 'Adószám',
  EUTaxNumber: 'EU adószám',
  Updated: 'Módosítva',
  Created: 'Létrehozva',
  Email: 'E-mail',
  Fax: 'Fax',
  Web: 'Honlap',
  Phone: 'Telefon',
  Felir: 'FELIR',
  RegistrationNumber: 'Cégjegyzékszám',
};

export const allColumns = [{
  value: 'Name',
  fixed: true,
}, {
  value: 'ShortName',
}, {
  value: 'TaxNumber',
}, {
  value: 'EUTaxNumber',
}, {
  value: 'Updated',
}, {
  value: 'Created',
}, {
  value: 'Email'
}, {
  value: 'Fax',
}, {
  value: 'Web',
}, {
  value: 'Phone'
}, {
  value: 'Felir'
}, {
  value: 'RegistrationNumber'
}];

export const defaultColumns = [{
  value: 'Name',
  fixed: true,
}, {
  value: 'ShortName',
}, {
  value: 'TaxNumber',
}, {
  value: 'EUTaxNumber',
}, {
  value: 'Phone',
}];

export const defaultSort = {
  prop: Name.propName,
  order: 'ascending'
};

export default {
  Created,
  Updated,
  Name,
  ShortName,
  TaxNumber,
  EUTaxNumber,
  Email,
  Fax,
  Web,
  Phone,
  Felir,
  RegistrationNumber,
};
